import { CommentMultipleIcon } from './CommentMultipleIcon';

/**
 * author: Michael Richins
 * id 63AC824E-16A4-4FBE-A6DF-588DEBCA47C1
 * name comment-multiple
 * version: 2.1.99
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/comment-multiple.svg
 * tags
 */
export const CommentsIcon = CommentMultipleIcon;
export default CommentsIcon